module.exports = __webpack_public_path__ + "2522c2d00d830e58d76ab2212f73d04e.png";